var prevScrollpos = 500;
window.onscroll = function () {
  var currentScrollPos = window.pageYOffset;
  if (prevScrollpos > currentScrollPos) {
    document.getElementById(
      "shopify-section-sections--18084284072105__announcement-bar"
    ).style.top = "-35px";
    document.getElementById(
      "shopify-section-sections--18084284072105__header"
    ).style.top = "0px";
  } else {
    document.getElementById(
      "shopify-section-sections--18084284072105__announcement-bar"
    ).style.top = "-80px"; /* adjust this value to the height of your header */
    document.getElementById(
      "shopify-section-sections--18084284072105__header"
    ).style.top = "-160px"; /* adjust this value to the height of your header */
  }

  prevScrollpos = currentScrollPos;
};
